export default {

    find:   { method: 'get',    url: 'teacher_work_regime_rules' },
    create: { method: 'post',   url: 'teacher_work_regime_rules'},
    update: { method: 'put',    url: 'teacher_work_regime_rules/{id}'},
    delete: { method: 'delete', url: 'teacher_work_regime_rules/{id}'}
}
